export function POCaption({ totalRows, totalQuantity }) {
  return (
    <div>
      <span>Total Rows: {totalRows}</span>
      <span style={{ marginLeft: "1rem" }}>Total Quantity Ordered: {totalQuantity}</span>
    </div>
  );
}

export function ASNCaption({ totalRows, totalQuantity }) {
  return (
    <div>
      <span>Total Rows: {totalRows}</span>
      <span style={{ marginLeft: "1rem" }}>Total Quantity Expected: {totalQuantity}</span>
    </div>
  );
}

export function COCaption({ totalRows, totalQuantity }) {
  return (
    <div>
      <span>Total Rows: {totalRows}</span>
      <span style={{ marginLeft: "1rem" }}>Total Quantity Ordered: {totalQuantity}</span>
    </div>
  );
}

export function PORecvCaption({ totalRows, totalQuantity, totalExpectedQuantity }) {
  return (
    <div>
      <span>Total Rows: {totalRows}</span>
      <span style={{ marginLeft: "1rem" }}>Total Quantity: {totalQuantity}</span>
      <span style={{ marginLeft: "1rem" }}>Total Expected Quantity: {totalExpectedQuantity}</span>
    </div>
  );
}

export function RecvCaption({ totalRows, totalQuantity }){
  return(
    <div>
      <span>Total Rows: {totalRows}</span>
      <span style={{ marginLeft: "1rem" }}>Total Quantity: {totalQuantity}</span>
    </div>
  )
}

export function CORecvCaption({ totalRows, totalQuantity, totalExpectedQuantity }) {
  return (
    <div>
      <span>Total Rows: {totalRows}</span>
      <span style={{ marginLeft: "1rem" }}>Total Quantity: {totalQuantity}</span>
      <span style={{ marginLeft: "1rem" }}>Total Expected Quantity: {totalExpectedQuantity}</span>
    </div>
  );
}
